<template>
	<div id="main">
	</div>
</template>

<script>
	import { imeilogin } from "@/api/index";
	import router from '@/router';
	export default {
		data() {
			return {
				loginForm:{
					account:"qadmin",
					password:"123456",
				},
				imei: ''
			}
		},
		computed: {
		},
		components: {
		},
		mounted() {
			const route = this.$route
			this.imei = route.query.imei
			if (this.imei) {
				this.user_login()
			}
		},
		methods: {
			user_login(){
				let params = {
					imei: this.imei
				};
				imeilogin(params).then((res) => {
					if (res.code == 1) {
						sessionStorage.setItem("token", res.data.userInfo.token);
						localStorage.setItem("HomeState","0");
						localStorage.setItem("userInfor",JSON.stringify(res.data.userInfo));
						localStorage.setItem("token",res.data.userInfo.token);			
						router.push({name:'home'});
						setTimeout(() => {
							window.location.reload();
						}, 500)
					}
				});
			},
		},
		beforeDestroy() {

		},

	}
</script>

<style scoped>
</style>
